import { render, staticRenderFns } from "./wisdomBusinessSuper.vue?vue&type=template&id=a2f3d966&scoped=true"
import script from "./wisdomBusinessSuper.vue?vue&type=script&lang=js"
export * from "./wisdomBusinessSuper.vue?vue&type=script&lang=js"
import style0 from "./wisdomBusinessSuper.vue?vue&type=style&index=0&id=a2f3d966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f3d966",
  null
  
)

export default component.exports